import { isDefined } from "@clipboard-health/util-ts";
import { isAxiosError } from "axios";
import { isObject } from "lodash";

export function getErrorMessage(error: unknown): string | undefined {
  if (!isAxiosError(error) || !isDefined(error.response) || !isObject(error.response.data)) {
    return undefined;
  }

  const incomingErrorMessage =
    "message" in error.response.data && typeof error.response.data.message === "string"
      ? error.response.data.message
      : undefined;

  return incomingErrorMessage;
}
